import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {NgbDropdownModule, NgbPopoverModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {NgSelectModule} from '@ng-select/ng-select';
import {AuthGuard, CmsConfig, I18nModule, provideDefaultConfig, UrlModule} from '@spartacus/core';
import {ListNavigationModule, MediaModule, PageSlotModule, PaginationConfig} from '@spartacus/storefront';

import {AimoInputModule} from '../../shared/input/aimo-input.module';
import {AimoInputSelectModule} from '../../shared/input-select/aimo-input-select.module';
import {AimoItemCounterModule} from '../../shared/item-counter/aimo-item-counter.module';
import {AimoCartSharedModule} from '../cart-shared/aimo-cart-shared.module';
import {AimoDeliveryDateModule} from '../cart-shared/delivery-date/aimo-delivery-date.module';
import {AimoProductListModule} from '../product/product-list/aimo-product-list.module';
import {AimoDatepickerModule} from '../shared/datepicker/aimo-datepicker.module';

import {AimoOrderHistoryComponent} from './aimo-order-history.component';
import {AimoOrderHistoryDayComponent} from './orderhistory-day/aimo-order-history-day.component';
import {AimoOrderHistoryOrderComponent} from './orderhistory-order/aimo-order-history-order.component';
import {AimoOrderHistoryOrderEntryComponent} from './orderhistory-order-entry/aimo-order-history-order-entry.component';
import {AimoOrderHistoryReorderComponent} from './reorder-modal/aimo-order-history-reorder.component';
import {reorderHistoryLayout} from './reorder-modal/reorder-layout.config';
import {AimoBreadcrumbModule} from "../navigation/breadcrumb/aimo-breadcrumb.module";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        NgSelectModule,
        ListNavigationModule,
        UrlModule,
        I18nModule,
        AimoInputModule,
        AimoDatepickerModule,
        ReactiveFormsModule,
        MediaModule,
        AimoDeliveryDateModule,
        NgbTooltipModule,
        NgbPopoverModule,
        NgbDropdownModule,
        AimoCartSharedModule,
        PageSlotModule,
        AimoInputSelectModule,
        AimoItemCounterModule,
        AimoProductListModule,
        AimoBreadcrumbModule,
    ],
    declarations: [
        AimoOrderHistoryComponent,
        AimoOrderHistoryOrderComponent,
        AimoOrderHistoryOrderEntryComponent,
        AimoOrderHistoryDayComponent,
        AimoOrderHistoryReorderComponent,
    ],
    exports: [
        AimoOrderHistoryComponent,
        AimoOrderHistoryOrderComponent,
        AimoOrderHistoryOrderEntryComponent,
        AimoOrderHistoryDayComponent,
        AimoOrderHistoryReorderComponent,
    ],
    providers: [
        provideDefaultConfig({
            pagination: {
                addStart: true,
                addEnd: true,
                addDots: true,
                addFirst: true,
                addLast: true,
                addNext: true,
                addPrevious: true,
                substituteDotsForSingularPage: true
            },
        } as PaginationConfig),
        provideDefaultConfig(reorderHistoryLayout),
        provideDefaultConfig(<CmsConfig>{
            cmsComponents: {
                AccountOrderHistoryComponent: {
                    component: AimoOrderHistoryComponent,
                    guards: [AuthGuard],
                },
            },
        }),

    ],
})
export class AimoOrderHistoryModule {
}
